import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-download-redirect',
    template: ''
})
export class AppDownloadRedirectComponent implements OnInit {

    androidIntent = 'intent://details?id=com.kripalunidhi#Intent;scheme=market;package=com.android.vending;end';
    iosAppStore = 'itms-apps://apps.apple.com/app/id1519473620';
    iosWebFallback = 'https://apps.apple.com/app/kripalu-nidhi/id1519473620?l=en';
    desktopLink = 'https://kripalunidhi.org';

    ngOnInit() {
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
        console.log('User agent:', userAgent);

        if (/android/i.test(userAgent)) {
            // ✅ Force open Play Store app
            window.location.href = this.androidIntent;
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            // ✅ Try native App Store scheme first
            window.location.href = this.iosAppStore;

            // ⏳ Fallback after 1.5s for desktop Safari or failed redirect
            setTimeout(() => {
                window.location.href = this.iosWebFallback;
            }, 1500);
        } else {
            // 🖥️ Desktop
            window.location.href = this.desktopLink;
        }
    }
}
